import _ from 'underscore';
import { locales } from './locales';
import { mapLocaleWebpack } from './map-locales';

export class BaseBundleRegistry {
  constructor(webpackLegacyI18nBundles) {
    this.registries = [];
    this.webpackLegacyI18nBundles = webpackLegacyI18nBundles;
  }

  loadWebpackLegacyI18nBundle(bundleName, locale) {
    const realLocale = mapLocaleWebpack(locale);
    const bundleConfig = this.webpackLegacyI18nBundles[bundleName];

    if (!bundleConfig) {
      throw new Error(`i18n bundle config not found ${bundleName}`);
    }

    const loadBundle = _.isFunction(bundleConfig) ? bundleConfig
      : (bundleConfig[realLocale] || bundleConfig[locales.English]); // Fallback to English

    if (!_.isFunction(loadBundle)) {
      throw new Error(`i18n bundle not found ${bundleName} ${locale}`);
    }

    const registryOrPromise = loadBundle();
    const handleRegistry = (registry) => { this.registries.push(registry.default); };

    // Allow for async or sync callback
    if (_.isFunction(registryOrPromise.then)) {
      return registryOrPromise.then(handleRegistry);
    }

    return handleRegistry(registryOrPromise);
  }

  loadDataPathWebpack({
    dataPath,
  }) {
    const foundRegistry = _.find(this.registries, registry => registry[dataPath]);
    const factory = foundRegistry ? foundRegistry[dataPath] : null;

    if (!_.isFunction(factory)) {
    // eslint-disable-next-line no-console
      console.error(`Cannot find webpack i18n for ${dataPath}`);

      return {};
    }

    return factory() || {};
  }
}
